import { IOfferForClient1 } from '../../repositories/chats/entities/for_client/OfferForClient1';
import { CHATBOT_ID } from '../../constants/chatbotId';
import {
  currentChatGaProductsSelector,
  currentChatMlSearchSessionGuidSelector,
  currentChatOwnerIdSelector,
  isEarlyAccessSelector,
  userIdSelector,
} from '../../selectors';
import { TThunkAction } from '../../types/redux/thunk';
import { createOutcomingMessage, prepareMessageReply } from '../../utils/messageUtils';
import { setSendMessagePending, trackMessageSent } from '../sendMessage';
import { sendWsMessage } from '../wsMessage';
import { IWsMessageReply } from '../wsMessage/types';

interface IProps {
  offer: IOfferForClient1;
  chatId: string;
  messageId?: string;
  reply?: IWsMessageReply | null;
}

export const sendOfferMessage =
  ({ offer, chatId, messageId, reply }: IProps): TThunkAction<void> =>
  async (dispatch, getState, context) => {
    const state = getState();
    const userId = userIdSelector(state);
    const ownerId = currentChatOwnerIdSelector(state);
    const mlSearchSessionGuid = currentChatMlSearchSessionGuidSelector(state);
    const isEarlyAccess = isEarlyAccessSelector(state);
    const products = currentChatGaProductsSelector(state);

    const { messagesMap } = context.custom;
    const messageReply = prepareMessageReply({ messagesMap, replyToMessageId: reply?.messageId });

    const message = createOutcomingMessage({ uid: messageId, chatId, userId, type: 'offer', reply: messageReply });
    message.offers = [offer];

    trackMessageSent({
      chatId,
      messageId: message.messageId,
      isReply: Boolean(messageReply),
      ownerId,
      mlSearchSessionGuid,
      isEarlyAccess,
      chatBotToAuthor: chatId === CHATBOT_ID,
      products,
    });

    dispatch(
      setSendMessagePending({
        message: { ...message, offers: [offer] },
        messageId: messageId || message.messageId,
        messagesMap,
      }),
    );

    await dispatch(sendWsMessage({ message, offers: [offer], reply }));
  };
